export const ACCOUNT_DELETION_PATH = 'delete-account'

export enum ACCOUNT_DELETION_TYPE {
  none,
  pending,
  deleted
}
